function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { SmallProductSquare } from "../../Square/SmallProductSquare/SmallProductSquare";
import styles from "./SmallProductSquareList.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var SmallProductSquareList = function SmallProductSquareList(_ref) {
  var products = _ref.products;
  var styleProductLength = "count".concat(products === null || products === void 0 ? void 0 : products.length);
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx("div", {
      className: classnames({
        [styles.list]: true,
        [styles[styleProductLength]]: styleProductLength in styles
      }),
      children: products === null || products === void 0 ? void 0 : products.map(function (product, key) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.item,
          children: /*#__PURE__*/_jsx(SmallProductSquare, _objectSpread({}, product))
        }, key);
      })
    })
  });
};